"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.acceptPromotionRequest = void 0;
const tslib_1 = require("tslib");
const immer_1 = require("immer");
const addSpeakers_1 = require("./addSpeakers");
const sendLiveSpaceData_1 = require("./helpers/sendLiveSpaceData");
const helpers_1 = require("../helpers");
const types_1 = require("../types");
function acceptPromotionRequest(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const { signalData, promoteeAddress, spaceId, role } = options || {};
        yield (0, addSpeakers_1.addSpeakers)({
            spaceId: this.spaceSpecificData.spaceId,
            signer: this.signer,
            pgpPrivateKey: this.pgpPrivateKey,
            speakers: [(0, helpers_1.pCAIP10ToWallet)(promoteeAddress)],
            env: this.env,
        });
        const modifiedLiveSpaceData = (0, immer_1.produce)(this.spaceSpecificData.liveSpaceData, (draft) => {
            const listenerIndex = this.spaceSpecificData.liveSpaceData.listeners.findIndex((listener) => (0, helpers_1.pCAIP10ToWallet)(listener.address) ===
                (0, helpers_1.pCAIP10ToWallet)(promoteeAddress));
            draft.listeners.splice(listenerIndex, 1);
            draft.speakers.push({
                address: (0, helpers_1.pCAIP10ToWallet)(promoteeAddress),
                emojiReactions: null,
                audio: null,
            });
        });
        yield (0, sendLiveSpaceData_1.default)({
            spaceId: this.spaceSpecificData.spaceId,
            pgpPrivateKey: this.pgpPrivateKey,
            env: this.env,
            signer: this.signer,
            liveSpaceData: modifiedLiveSpaceData,
            action: types_1.CHAT.META.SPACE.SPEAKER.PRVILEGE,
        });
        // accept the promotion request
        // this.acceptRequest({
        //   signalData,
        //   senderAddress: this.data.local.address,
        //   recipientAddress: pCAIP10ToWallet(promoteeAddress),
        //   chatId: spaceId,
        //   details: {
        //     type: SPACE_ACCEPT_REQUEST_TYPE.ACCEPT_PROMOTION,
        //     data: {},
        //   },
        // });
    });
}
exports.acceptPromotionRequest = acceptPromotionRequest;
//# sourceMappingURL=acceptPromotionRequest.js.map